export default __webpack_public_path__ + "static/media/pointing-up.4805ffed.png";